import {RelationshipType} from "./relationship-type";

export class DeterminantRegistrationRelations {
  public registrationId: string;
  public registrationName: string;
  public registrationShortName: string;
  public relationshipType: RelationshipType;
  public determinantGroupName: string;
  public jsonDeterminants: string;
  public serviceId: string;
}
